import "./Quiz.css";

function Options({ question, selectedAnswer, onSelect }) {
  if (!question || !question.options) return null;

  return (
    <ul className="options-list">
      {question.options.map((option, index) => (
        <li
          key={index}
          className={`option-item ${selectedAnswer === index ? "selected" : ""}`}
          onClick={() => onSelect(index)}
        >
          <span className="option-label">{String.fromCharCode(65 + index)}.</span>
          <span>{option}</span>
        </li>
      ))}
    </ul>
  );
}

export default Options;
